/* loaded by smart-asset */
export default require("./assets/drop-zone.i.svg")